// extracted by mini-css-extract-plugin
export default {"sidebar-links":"SideBarLinks_sidebar-links__O8tBI"};